import { useCallback } from 'react';

// Helper function to get local date string (avoid timezone issues)
const getLocalDateString = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const useTaskCompletion = (userId, dashboardType) => {
  const markTaskCompleted = useCallback((date = null) => {
    if (!userId || !dashboardType) return;
    
    const targetDate = date || new Date();
    const dateStr = getLocalDateString(targetDate);
    const activityKey = `dailyActivity_${dashboardType}_${userId}`;
    
    console.log(`Marking task completed for date: ${dateStr} (local date)`);
    
    const currentActivity = JSON.parse(localStorage.getItem(activityKey) || '{}');
    currentActivity[dateStr] = true; // Task completed
    
    localStorage.setItem(activityKey, JSON.stringify(currentActivity));
    console.log(`Saved to localStorage:`, currentActivity);
    
    // Dispatch custom event to update calendar
    window.dispatchEvent(new CustomEvent('taskCompleted', {
      detail: { date: dateStr, userId, dashboardType }
    }));
  }, [userId, dashboardType]);

  const markNoTask = useCallback((date = null) => {
    if (!userId || !dashboardType) return;
    
    const targetDate = date || new Date();
    const dateStr = getLocalDateString(targetDate);
    const activityKey = `dailyActivity_${dashboardType}_${userId}`;
    
    console.log(`Marking no task for date: ${dateStr} (local date)`);
    
    const currentActivity = JSON.parse(localStorage.getItem(activityKey) || '{}');
    currentActivity[dateStr] = false; // No task completed
    
    localStorage.setItem(activityKey, JSON.stringify(currentActivity));
    
    // Dispatch custom event to update calendar
    window.dispatchEvent(new CustomEvent('taskCompleted', {
      detail: { date: dateStr, userId, dashboardType }
    }));
  }, [userId, dashboardType]);

  return { markTaskCompleted, markNoTask };
};



